const convertModeToModeFlags = (mode) => {
    switch (mode) {
        case "landing" /* HeaderMode.LANDING */:
            return {
                isShowLogo: true,
                isShowMenu: false,
                isShowSearch: false,
                isShowUser: false,
            };
        case "menuOff" /* HeaderMode.MENU_OFF */:
            return {
                isShowLogo: true,
                isShowMenu: false,
                isShowSearch: false,
                isShowUser: true,
            };
        default:
            return {
                isShowLogo: true,
                isShowMenu: true,
                isShowSearch: false,
                isShowUser: true,
            };
    }
};

export { convertModeToModeFlags };
//# sourceMappingURL=mode.js.map
